import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

const Contact = () => {
  return (
    <div>

    <div class="container">
      <div class="row">
        <div class="col-xs-10.25 col-md-8 col-lg-10">
          <div class="white-box">
            
            <h6 class="contact-info">If you have any questions about my portfolio, or are interested in collaborating, feel free to contact me:</h6>
            <ul>
              <li>
                <p>Email: sydneyjogoodwill@gmail.com</p>
              </li>
              <li>
                <p>Check out my <a href="https://www.linkedin.com/in/sydney-goodwill-670828199/">LinkedIn</a> profile.</p>
                </li>
                <li><p>You can also find a copy of my <a href="https://docs.google.com/document/d/1tWFm28m_l3ojeyWH6q1dU_-IpvcN43ZXgpE4Wpkwrl8/edit#heading=h.ocvpswguxa6m">Resume</a> here!
             </p>
                </li>
            </ul>
          </div>
          </div>
        </div>
      </div>
    </div>
  )
};

export default Contact;